import { render, staticRenderFns } from "./get-friendly-name.vue?vue&type=template&id=729e044f&scoped=true&"
import script from "./get-friendly-name.vue?vue&type=script&lang=tsx&"
export * from "./get-friendly-name.vue?vue&type=script&lang=tsx&"
import style0 from "./get-friendly-name.vue?vue&type=style&index=0&id=729e044f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729e044f",
  null
  
)

export default component.exports